import initializeOcpsPolicyStore from './initializeOcpsPolicyStore';
import { logUsage } from 'owa-analytics';
import { getItem, itemExists } from 'owa-local-storage';
import { USER_OCPS_POLICY_STORE } from './constants';
import type { OcpsPolicyStore } from '../store/schema/OcpsPolicyStore';
import { updateOcpsLocalStorage } from './updateOcpsLocalStorage';

export function shouldRetryFetchPoliciesAndSetStore(): void {
    const maxRetries = 1;
    if (itemExists(window, USER_OCPS_POLICY_STORE)) {
        const ocpsPolicyStore: OcpsPolicyStore = JSON.parse(
            getItem(window, USER_OCPS_POLICY_STORE) ?? ''
        );
        let retryCount = ocpsPolicyStore.retryFetchCount ?? 0;

        if (retryCount < maxRetries) {
            try {
                retryCount++;
                ocpsPolicyStore.retryFetchCount = retryCount;
                updateOcpsLocalStorage(ocpsPolicyStore, 'RETRY');

                // Fetch the store here
                initializeOcpsPolicyStore('RetryFetchPoliciesAndSetStore');
            } catch (error) {
                /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param, owa-custom-rules/forbid-specific-functions-on-catch-finally-blocks -- (https://aka.ms/OWALintWiki)
                 * BASELINE: DO NOT COPY/PASTE!
                 * undefined
                 *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo
                 (https://aka.ms/OWALintWiki)
                                 * Baseline. Dev touching this file must update to pass the active MailboxInfo; Docs: https://aka.ms/owa-analytics-mailboxinfo
                                 * undefined
                                 *	> MailboxInfo must be passed into the function to identify the account.
                                 (https://aka.ms/OWALintWiki)
                                                 * BASELINE. DO NOT COPY AND PASTE!, replace this line with a justification or fix the error, use PerformanceDatapoint instead.
                                                 *	> Do not call 'logUsage' from 'owa-analytics' inside catch or finally blocks */
                logUsage('FetchPoliciesAndSetStore_RetryFailed', undefined, {
                    // Errors resulting from enabling useUnknownInCatchVariables
                    // TS18046: 'error' is of type 'unknown'.
                    // @ts-expect-error
                    error: error.message,
                    // Errors resulting from enabling useUnknownInCatchVariables
                    // TS18046: 'error' is of type 'unknown'.
                    // @ts-expect-error
                    stack: error.stack,
                });
            }
        }
    }
}
